
export const errors = {
  'error': 'Error',
  'error.title': 'Error',
  'error.invalid.credentials': 'Invalid credentials',
  'error.signin': 'Sign in error',
  'error.signout': 'Sign out error',
  'error.generic': 'An unexpected error occurred',
  'error.missing.email': 'Email is required',
  'error.invalid.recovery.link': 'Invalid recovery link',
  'error.password.requirements': 'Password does not meet requirements',
  'error.password.update': 'Password update failed',
  'error.authentication': 'Authentication error',
  'error.permission': 'Permission denied',
  'error.update.preferences': 'Failed to update preferences',
  'errors.invalid.credentials': 'Invalid credentials',
  'errors.email.not.confirmed': 'Email not confirmed',
  'errors.user.not.found': 'User not found',
  'errors.invalid.email.password': 'The email or password you entered is incorrect',
  'errors.missing.email.phone': 'Email or phone number is required',
  'errors.missing.password': 'Password is required',
  'errors.password.too.short': 'Password is too short',
  'errors.email.taken': 'Email is already taken',
  'errors.phone.taken': 'Phone number is already taken',
  'errors.weak.password': 'Password is too weak',
  'errors.invalid.email': 'Invalid email format',
  'errors.invalid.phone': 'Invalid phone number format',
  'errors.generic': 'An unexpected error occurred',
  'errors.signin': 'Sign in error',
  'errors.signout': 'Sign out error',
  'errors.password.update': 'Password update failed',
  'errors.missing.email': 'Email is required',
  'errors.invalid.recovery.link': 'Invalid recovery link',
  'errors.password.requirements': 'Password does not meet requirements',
  'errors.current.password': 'Current password is incorrect',
  'errors.update.preferences': 'Failed to update preferences',
  'errors.passwords.dont.match': 'Passwords do not match',
  'errors.invalidFileType': 'Invalid file type',
  'errors.fileTooLarge': 'File is too large',
  'errors.avatarUpload': 'Failed to upload avatar',
  'errors.update.status': 'Failed to update status',
  'errors.authentication': 'Authentication error',
  'errors.permission': 'Permission denied',
  'errors.unexpected': 'Unexpected error occurred',
  'errors.missing_data': 'Required data is missing',
  'errors.missing_email_or_name': 'Email and display name are required',
  'errors.email_failed': 'Failed to send email',
  'errors.activation_email_failed': 'Failed to send activation email',
  'errors.invalid_input': 'Invalid input data',
  'errors.enter_valid_number': 'Please enter a valid number',
  'errors.update_failed': 'Update failed',
  'errors.url_limits_update_failed': 'Failed to update URL limits',
  'errors.subscription_update_failed': 'Failed to update subscription',
  'errors.delete_failed': 'Delete operation failed',
  'errors.user_delete_failed': 'Failed to delete user',
  'errors.user_banned': 'This user account has been suspended',
  'monitoring.url.error.approve': 'Failed to approve URL',
  'monitoring.url.error.reject': 'Failed to reject URL'
};
